//
// Purpose: SAMB - group table component
// Author: Ronny Van Elewyck
// Version: 1.0
// Creation Date: 04.06.2020
// Modification Date: 04.06.2020
//

// installed components
import React from "react";

// created components
import GroupRow from "./groupRow";

const GroupTable = ({
  listArray,
  changeItem,
  copyItem,
  deleteItem,
  isAdmin,
}) => {
  return (
    <div className="table-responsive">
      <table className="table table-bordered">
        <thead className="thead-light">
          <tr>
            {isAdmin && <th></th>}
            {isAdmin && <th></th>}
            {isAdmin && <th></th>}
            <th>klassen</th>
          </tr>
        </thead>
        <tbody>
          {listArray.map((item) => (
            <GroupRow
              key={item.groupid1}
              item={item}
              changeItem={changeItem}
              copyItem={copyItem}
              deleteItem={deleteItem}
              isAdmin={isAdmin}
            />
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default GroupTable;
